import { useTranslation } from "react-i18next";
import type { AutoRenewUpdateNotification } from "@/gql/graphql";
import DataListItemText from "./DataListItemText";

type NotificationProps = {
  data: Pick<
    AutoRenewUpdateNotification,
    "autoRenew" | "contractNumber" | "customerName"
  >;
};

const AutoRenewNotification = (props: NotificationProps) => {
  const { data } = props;
  const { contractNumber, autoRenew, customerName } = data;

  const { t } = useTranslation();

  // Compute title based on whether customerName exists
  const title = customerName
    ? t("notifications.auto_renew_update.title_customer", {
        contractNumber,
        customerName,
      })
    : t("notifications.auto_renew_update.title_generic", {
        contractNumber,
      });

  return (
    <DataListItemText
      primary={title}
      secondary={t(
        `notifications.auto_renew_update.description_${autoRenew ? "enabled" : "disabled"}`,
        {
          autoRenew,
        }
      )}
    />
  );
};

export default AutoRenewNotification;
